/* Geo-route fail-safe (Jenn 6/2): on hardware PDPs, route confident out-of-US
   visitors to Request-a-Quote instead of the US-only checkout.

   Fail-safe by design: the default (server-rendered, cached) state is the US buy
   button. We ONLY restrict on a confident non-US signal, so a misclassified US
   buyer is never blocked, and JS-off / ad-blocked international visitors are no
   worse off than today (they just see the buy button, same as before).

   Interim stopgap: localization.country (the Liquid gate in product-information.liquid)
   is the authoritative, cache-safe layer once Shopify Markets per-market URLs +
   automatic redirection are configured. Until then this catches the single-domain
   default-US case. Safe to remove once Markets redirection is on. */
(function () {
  // Only runs on hardware PDPs (the gate renders the quote CTA there).
  if (!document.querySelector('[data-hi-quote-cta]')) return;

  function restrictToQuote(country) {
    // Direct-buy allow-list: tagged products keep the buy button for countries with
    // real checkout rates (data-hi-allow, server-rendered from the Liquid list).
    var allowEl = document.querySelector('[data-hi-buy-wrap][data-hi-allow]');
    if (allowEl && country && allowEl.getAttribute('data-hi-allow').split(',').indexOf(country) !== -1) return;
    document.querySelectorAll('[data-hi-buy-wrap]').forEach(function (el) { el.setAttribute('hidden', ''); });
    var sticky = document.getElementById('AddToCartSticky');
    if (sticky) {
      var bar = sticky.closest('product-add-to-cart-sticky');
      (bar || sticky).setAttribute('hidden', '');
    }
    document.querySelectorAll('[data-hi-panel]').forEach(function (el) { el.setAttribute('hidden', ''); });
    document.querySelectorAll('[data-hi-quote-cta]').forEach(function (a) {
      a.removeAttribute('hidden');
      // Pass the detected country to the quote page so the submission is flagged international.
      var href = a.getAttribute('href');
      if (country && href && href.indexOf('geo=') === -1) {
        a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'geo=' + encodeURIComponent(country));
      }
    });
    document.querySelectorAll('[data-hi-quote-note]').forEach(function (el) { el.removeAttribute('hidden'); });
  }

  function check() {
    // QA override: ?geo_test=NO forces the non-US (quote) experience from any IP;
    // ?geo_test=US forces the normal buy experience. Lets us verify the JS layer
    // without a VPN. Harmless in production (only affects the URL that sets it).
    try {
      var m = window.location.search.match(/[?&]geo_test=([a-zA-Z]{2})/);
      if (m) { if (m[1].toUpperCase() !== 'US') restrictToQuote(m[1].toUpperCase()); return; }
    } catch (e) { /* ignore */ }

    var done = false;
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 2500);
    fetch('https://get.geojs.io/v1/ip/country.json', ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return (r && r.ok) ? r.json() : null; })
      .then(function (data) {
        clearTimeout(timer);
        if (done || !data) return;
        done = true;
        var country = (data.country || '').toUpperCase();
        // Confident, explicit non-US only. Empty/unknown => leave US buy visible (fail safe).
        if (country && country !== 'US') restrictToQuote(country);
      })
      .catch(function () { clearTimeout(timer); /* network / abort / blocked => fail safe, do nothing */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
